import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";

export default function Field({ label, value, onChange, testId, hint, big }) {
  return (
    <div className="st-field">
      <Label htmlFor={testId} className="st-label">{label}</Label>
      <Input
        id={testId}
        data-testid={testId}
        value={value}
        onChange={(e) => onChange(e.target.value)}
        className={`st-input ${big ? "st-input--big" : ""}`}
      />
      {hint && <p className="st-hint">{hint}</p>}
    </div>
  );
}
